import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import useStyles from './Spinner.styles';

const Spinner = (props) => {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  return (
    <div className={classes.spinner} />
  );
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['large', 'small', 'radio', 'extra-small']).isRequired,
};

export default Spinner;
